import React from 'react';
import {
  CardText,
  ClockIconWrapper,
  CustomCard,
  CustomCardContent,
  InsightsCardTitle,
  PercentageBar,
  PercentageBarContainer,
  PercentageBarRow,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/styles';
import { useCategoryColor } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/hooks';
import { TabValue } from 'spw-esa-projects/building-details/occupancy-and-utilization/types';
import {
  CategoryDotWrapper,
  ColorDot,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/styles';
import { Box } from '@mui/material';
import { RoundWithOccupancy } from 'spw-redux/modules/ou/types';
import { asPercentageRounded, numberWithCommasOrDash } from 'spw-shared/utils';
import moment from 'moment/moment';

type Props = {
  category: TabValue;
  round: RoundWithOccupancy;
};

const LowestOccupancy = ({ category, round }: Props) => {
  const color = useCategoryColor(category);
  return (
    <CustomCard elevation={0} className="margin-top-16">
      <CustomCardContent>
        <InsightsCardTitle>
          <CategoryDotWrapper>
            <ColorDot color={color} className="colorDot" />
          </CategoryDotWrapper>
          <Box display="flex">Lowest Occupancy</Box>
        </InsightsCardTitle>
        <PercentageBarRow>
          <Box className="value">
            {round?.occupancy === undefined
              ? '--'
              : asPercentageRounded(round?.occupancy)}
          </Box>
          <Box
            display="flex"
            flex={1}
            justifyContent="center"
            alignItems="center"
          >
            <PercentageBarContainer>
              <PercentageBar
                width={`${Math.min(round.occupancy, 1.0) * 100}%`}
                color={color}
              />
            </PercentageBarContainer>
          </Box>
        </PercentageBarRow>
        <CardText style={{ marginBottom: 16 }}>
          <Box display="flex">
            <ClockIconWrapper>
              <img src="/images/icons/clock-icon.svg" alt="Clock icon" />
            </ClockIconWrapper>
            <Box>
              <p>
                <b>
                  {moment(round.date).format('dddd').toUpperCase()}{' '}
                  {round.startTime}
                </b>
              </p>
              <p>{moment(round.date).format('MMM DD, yyyy')}</p>
            </Box>
          </Box>
        </CardText>

        <CardText>
          <p>
            <b>{numberWithCommasOrDash(round?.observedSpacesInUse)}</b> Observed
            Spaces In Use /
          </p>
          <p>
            <b>{numberWithCommasOrDash(round?.observedSpaces)}</b> Observed
            Spaces
          </p>
        </CardText>
      </CustomCardContent>
    </CustomCard>
  );
};

export default LowestOccupancy;
